// React
import React, { useState, useEffect } from "react";
// React
// CSS
import styles from "./OTP.module.css";
// CSS
// Components
import Step1 from "./Step1/Step1";
import Step2 from "./Step2/Step2";
import Step3 from "./Step3/Step3";
import { Navigate } from "react-router-dom";
// Components

type OTP_Props = {
  setUserToken: React.Dispatch<React.SetStateAction<string>>;
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const OTP: React.FunctionComponent<OTP_Props> = ({
  setUserToken,
  setIsNeedFullScreen,
}) => {
  // ************************************************** States
  const [formStep, setFormStep] = useState<1 | 2 | 3>(1);
  const [userPhoneNumber, setUserPhoneNumber] = useState<number | string>(NaN);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isRegisterNeed, setIsRegisterNeed] = useState<boolean>(true);
  // ************************************************** States

  useEffect(() => {
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  }, [setIsNeedFullScreen]);

  return (
    <div
      className={`w-screen h-screen overflow-hidden flex items-center justify-center relative ${styles.otpContainer} `}
    >
      {/* Circles */}
      <div className={`${styles.circle1} ${styles.circle} absolute`}></div>
      <div className={`${styles.circle2} ${styles.circle} absolute`}></div>
      {/* Circles */}
      {/* FormSteps */}
      {formStep === 1 && (
        <Step1
          setFormStep={setFormStep}
          setUserPhoneNumber={setUserPhoneNumber}
          userPhoneNumber={Number(userPhoneNumber)}
          isPending={isPending}
          setIsPending={setIsPending}
          isRegisterNeed={isRegisterNeed}
          setIsRegisterNeed={setIsRegisterNeed}
        />
      )}
      {/*  */}
      {formStep === 2 && (
        <Step2
          formStep={formStep}
          setUserToken={setUserToken}
          userPhoneNumber={Number(userPhoneNumber)}
          setFormStep={setFormStep}
          isPending={isPending}
          setIsPending={setIsPending}
        />
      )}
      {/*  */}
      {formStep === 3 ? (
        <>
          {isRegisterNeed ? (
            <Step3
              formStep={formStep}
              userPhoneNumber={Number(userPhoneNumber)}
              isRegisterNeed={isRegisterNeed}
            />
          ) : (
            <Navigate to={"/"} />
          )}
        </>
      ) : (
        <></>
      )}
      {/* FormSteps */}
    </div>
  );
};

export default OTP;
